import React from 'react';
import FigmaBadge from '../Elements/FigmaBadge';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import UserNameComponent from '../Elements/UserNameComponent';

export default class EndOfMonthItem
{
  constructor (item)
  {
    if (item === undefined)
    {
      this.EndOfMonthId = '';
      this.RevenuePeriod = '';
      this.SuggestedInvoiceFinalizationEndDateUtc = null;
      this.SuggestedPaymentExportDateUtc = null;
      this.IsApproved = false;
      this.ApprovedOnUtc = null;
      this.ApprovedBy = null;
      this.InvoiceFinalizationEndDateUtc = null;
      this.PaymentExportDateUtc = null;
      this.CreatedOnUtc = null;
      this.CreatedBy = '';
      this.ModifiedOnUtc = null;
      this.ModifiedBy = '';
      return;
    }

    this.EndOfMonthId = item.endOfMonthId;
    this.RevenuePeriod = item.revenuePeriod;
    this.SuggestedInvoiceFinalizationEndDateUtc = item.suggestedInvoiceFinalizationEndDateUtc;
    this.SuggestedPaymentExportDateUtc = item.suggestedPaymentExportDateUtc;
    this.IsApproved = item.approvedOnUtc != null;
    this.ApprovedOnUtc = item.approvedOnUtc;
    this.ApprovedBy = item.approvedBy;
    this.InvoiceFinalizationEndDateUtc = item.invoiceFinalizationEndDateUtc ? item.invoiceFinalizationEndDateUtc : item.suggestedInvoiceFinalizationEndDateUtc;
    this.PaymentExportDateUtc = item.paymentExportDateUtc ? item.paymentExportDateUtc : item.suggestedPaymentExportDateUtc;
    this.CreatedOnUtc = item.createdOnUtc;
    this.CreatedBy = item.createdBy;
    this.ModifiedOnUtc = item.modifiedOnUtc;
    this.ModifiedBy = item.modifiedBy;
  }

  static displayedInList = 'RevenuePeriod';

  static NameOfTheIdField ()
  {
    return 'EndOfMonthId';
  }

  static nameOfTheItemDetailList ()
  {
    return 'End Of Month Details';
  }

  static DateFields = [
    'SuggestedInvoiceFinalizationEndDateUtc',
    'SuggestedPaymentExportDateUtc',
    'ApprovedOnUtc',
    'InvoiceFinalizationEndDateUtc',
    'PaymentExportDateUtc',
    'CreatedOnUtc',
    'ModifiedOnUtc',
  ];

  static FieldsToShowInDataTable ()
  {
    return [
      { label: 'Revenue Period', orderById: 'RevenuePeriod', data: 'RevenuePeriod' },
      {
        label: 'Suggested Invoice Finalization End',
        orderById: 'SuggestedInvoiceFinalizationEndDateUtc',
        data: 'SuggestedInvoiceFinalizationEndDateUtc',
      },
      {
        label: 'Suggested Payment Export',
        orderById: 'SuggestedPaymentExportDateUtc',
        data: 'SuggestedPaymentExportDateUtc',
      },
      {
        label: 'Invoice Finalization End',
        orderById: 'InvoiceFinalizationEndDateUtc',
        data: 'InvoiceFinalizationEndDateUtc',
      },
      { label: 'Payment Export', orderById: 'PaymentExportDateUtc', data: 'PaymentExportDateUtc' },
      {
        label: 'Approved?',
        orderById: 'IsApproved',
        data: (item) => EndOfMonthItem.getIsActiveCellContent(item.IsApproved),
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      { label: 'Approved On', orderById: 'ApprovedOnUtc', data: 'ApprovedOnUtc' },
      { label: 'Approved By', orderById: 'ApprovedBy', data: (item) => <UserNameComponent userId={item.ApprovedBy} /> },
      {
        label: ' ',
        orderById: 'EndOfMonthId',
        data: EndOfMonthItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static toggleApproval = (item) =>
  {
    alert('Approval function');
  };

  static editFunction = (id, item, itemList) =>
  {
    alert('Empty function');
  };

  static getActionsContent (item)
  {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: item.IsWaveLinkingEnabled ? 'fa-solid fa-trash-can' : 'fa-solid fa-check',
            text: item.ApprovedOnUtc ? 'Remove Approval' : 'Approve EOM',
            onClick: () => EndOfMonthItem.toggleApproval(item),
            roleKey: 'eom_setup',
          },
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => EndOfMonthItem.editFunction(item.EndOfMonthId, item),
            roleKey: 'eom_setup',
          },
        ]}
      />
    );
  }

  static getIsActiveCellContent (item)
  {
    return (
      <div className='pointer'>
        {
          <FigmaBadge
            Active={item}
            ActiveText='Yes'
            InactiveText='No'
            width={50}
          />
        }
      </div>
    );
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'EndOfMonthId', label: 'End Of Month ID' },
        { name: 'RevenuePeriod', label: 'Revenue Period' },
      ],
    },
  ];
}
